import { render, staticRenderFns } from "./template15.vue?vue&type=template&id=04cd5a4d&scoped=true"
import script from "./template15.vue?vue&type=script&lang=js"
export * from "./template15.vue?vue&type=script&lang=js"
import style0 from "./template15.vue?vue&type=style&index=0&id=04cd5a4d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cd5a4d",
  null
  
)

export default component.exports